// src/actions/likeDislikeActions.js

import axios from 'axios';
// Assuming baseURL is defined in your types file, otherwise the hardcoded URL is used.
import { baseURL } from './types'; 
import {

    GET_ALL_LIKES_REQUEST,
    GET_ALL_LIKES_SUCCESS,
    GET_ALL_LIKES_FAIL, 
    GET_ONE_LIKE_REQUEST,
    GET_ONE_LIKE_SUCCESS,
    GET_ONE_LIKE_FAIL,
    CREATE_LIKE_REQUEST,
    CREATE_LIKE_SUCCESS,
    CREATE_LIKE_FAIL,
    UPDATE_LIKE_REQUEST,
    UPDATE_LIKE_SUCCESS,
    UPDATE_LIKE_FAIL,
    DELETE_LIKE_REQUEST,
    DELETE_LIKE_SUCCESS,
    DELETE_LIKE_FAIL,
    GET_LIKES_BY_PATIENT_REQUEST,
    GET_LIKES_BY_PATIENT_SUCCESS,
    GET_LIKES_BY_PATIENT_FAIL
} from './types';

// Helper function to get the auth token and create headers
const getConfig = () => {
    const token = localStorage.getItem('token'); 
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
};

// Define the API endpoint for consistency
const API_ENDPOINT = `${baseURL}/api/appointmentDoctorLikeDislike`;

// --- NEW ACTION: Get all likes/dislikes by the logged-in patient ---
export const getLikesByPatient = () => async (dispatch) => {
    dispatch({ type: GET_LIKES_BY_PATIENT_REQUEST });
    try {
        const loginDataString = localStorage.getItem('loginData');
        if (!loginDataString) {
            throw new Error("No login data found. Please log in.");
        }
        
        const loginData = JSON.parse(loginDataString);
        // Assuming the patient's ID is stored in the 'hospitalID' field of the loginData object
        const patientId = loginData.hospitalID; 

        if (!patientId) {
            throw new Error("Patient ID could not be found in your login data.");
        }
        
        // The payload tells the /getall endpoint to filter by PatientID
        const payload = { PatientID: patientId };
        const config = getConfig();
        
        const res = await axios.post(`${API_ENDPOINT}/getall`, payload, config); 
        
        dispatch({
            type: GET_LIKES_BY_PATIENT_SUCCESS,
            payload: res.data.data,
        });
    } catch (err) {
        dispatch({
            type: GET_LIKES_BY_PATIENT_FAIL,
            payload: err.response?.data?.message || err.message,
        });
    }
};

// Get all Like/Dislike records for a specific DOCTOR
export const getAllLikesByDoctor = (payload) => async (dispatch) => {
    dispatch({ type: GET_ALL_LIKES_REQUEST });
    try {
        const config = getConfig();
        const res = await axios.post(`${API_ENDPOINT}/getall`, payload, config); 
        dispatch({
            type: GET_ALL_LIKES_SUCCESS,
            payload: res.data.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ALL_LIKES_FAIL,
            payload: err.response?.data.message || err.message,
        });
    }
};

// Get a single Like/Dislike record
export const getOneLike = (payload) => async (dispatch) => {
    dispatch({ type: GET_ONE_LIKE_REQUEST });
    try {
        const config = getConfig();
        const res = await axios.post(`${API_ENDPOINT}/getone`, payload, config);
        dispatch({
            type: GET_ONE_LIKE_SUCCESS,
            payload: res.data.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ONE_LIKE_FAIL,
            payload: err.response?.data.message || err.message,
        });
    }
};

// Create a new Like/Dislike record
export const createLikeDislike = (payload) => async (dispatch) => {
    dispatch({ type: CREATE_LIKE_REQUEST });
    try {
        const config = getConfig();
        const res = await axios.post(`${API_ENDPOINT}/create`, payload, config);
        dispatch({
            type: CREATE_LIKE_SUCCESS,
            payload: res.data.data,
        });
    } catch (err) {
        dispatch({
            type: CREATE_LIKE_FAIL,
            payload: err.response?.data.message || err.message,
        });
    }
};

// Update an existing Like/Dislike record
export const updateLikeDislike = (payload) => async (dispatch) => {
    dispatch({ type: UPDATE_LIKE_REQUEST });
    try {
        const config = getConfig();
        const res = await axios.patch(`${API_ENDPOINT}/update`, payload, config);
        dispatch({
            type: UPDATE_LIKE_SUCCESS,
            payload: res.data.data,
        });
    } catch (err) {
        dispatch({
            type: UPDATE_LIKE_FAIL,
            payload: err.response?.data.message || err.message,
        });
    }
};

// Delete a Like/Dislike record
export const deleteLikeDislike = (id) => async (dispatch) => {
    return new Promise(async (resolve, reject) => {
        dispatch({ type: DELETE_LIKE_REQUEST });
        try {
            const config = getConfig();
            // To send a body with axios.delete, it must be in the 'data' property
            config.data = { id: id };
            
            const url = `${API_ENDPOINT}/delete`;
            
            await axios.delete(url, config);
            
            dispatch({
                type: DELETE_LIKE_SUCCESS,
                payload: id, 
            });
            resolve(); // Resolve the promise on success
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.message;
            dispatch({
                type: DELETE_LIKE_FAIL,
                payload: errorMessage,
            });
            reject(err); // Reject the promise on failure
        }
    });
};